import React from "react";

const Footer = () => {
  return (
    <footer
      className="footer padding-global padding-section-large"
      style={{
        background: "linear-gradient(135deg, #FBFAFF, #F5F2FF)",
        color: "#6B46C1",
        borderTop: "1px solid rgba(139, 95, 191, 0.15)",
        marginTop: 0,
      }}
    >
      <div className="container-large text-align-center">
        <p className="footer-text" style={{ color: "#8B5FBF", fontSize: "0.95rem" }}>
          &copy; 2025 OKGather. All rights reserved. |{" "}
          <a
            href="/blog"
            className="footer-link"
            style={{
              color: "#6B46C1",
              textDecoration: "underline",
              transition: "color 0.3s ease",
            }}
          >
            Blog
          </a>{" "}
          |{" "}
          <a
            href="/local-events"
            className="footer-link"
            style={{
              color: "#6B46C1",
              textDecoration: "underline",
              transition: "color 0.3s ease",
            }}
          >
            City Guides
          </a>{" "}
          |{" "}
          <a
            href="/terms"
            className="footer-link"
            style={{
              color: "#6B46C1",
              textDecoration: "underline",
              transition: "color 0.3s ease",
            }}
          >
            Terms
          </a>{" "}
          |{" "}
          <a
            href="/privacy"
            className="footer-link"
            style={{
              color: "#6B46C1",
              textDecoration: "underline",
              transition: "color 0.3s ease",
            }}
          >
            Privacy
          </a>{" "}
          |{" "}
          <a
            href="/faq"
            className="footer-link"
            style={{
              color: "#6B46C1",
              textDecoration: "underline",
              transition: "color 0.3s ease",
            }}
          >
            FAQ
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
